/* eslint-disable react/jsx-pascal-case */

import React from 'react'
import PropTypes, { InferProps } from 'prop-types'
import styled from 'styled-components'
import { themeGet } from '@styled-system/theme-get'
import { Flex, Text, Box, Link } from 'pcln-design-system'
import { WebPBackgroundImage } from '@pcln/content-tile'
import AppleStore from './graphics/AppleStoreSvg'
import PlayStore from './graphics/PlayStoreSvg'
import analytics from '../../utils/analytics'
import APP_DOWNLOAD_CONTENT from '../../constants/promotions/app-download'

const StyledLink = styled(Link)`
  margin-right: 8px;
`

const WrapperFlex = styled(Flex)`
  margin: 0 auto;
  max-width: 1280px;
`

const FlexDesktopOnly = styled(Flex)`
  display: none;
  ${themeGet('mediaQueries.lg')} {
    display: flex;
    flex: 1;
  }
`

const StyledWebPImage = styled(WebPBackgroundImage)`
  visibility: hidden;
  background-position: right;
  ${themeGet('mediaQueries.lg')} {
    visibility: visible;
    background-color: transparent;
    background-size: ${(props: { imageSize: string }) => props.imageSize};
    flex: 1;
  }
`

export default function AppDownload({
  category
}: InferProps<typeof AppDownload.propTypes>) {
  const {
    buttons,
    contentText1,
    contentText2,
    contentText3,
    gaAction,
    headingText,
    image,
    imageSize,
    imageWebP,
    smallHeadingText
  } = APP_DOWNLOAD_CONTENT

  const appDownloadButtons = buttons.map(button => {
    const { gaLabel } = button
    return (
      <StyledLink
        href={button.linkUrl}
        target="_blank"
        rel="noopener"
        key={gaLabel}
        onClick={() => {
          analytics.fireEvent({
            category,
            action: gaAction,
            label: gaLabel
          })
        }}
        aria-label={`Mobile app - ${gaLabel}`}
      >
        {gaLabel === 'Android' ? <PlayStore /> : <AppleStore />}
      </StyledLink>
    )
  })

  return (
    <Box width={1} p={1} color="background.light">
      <WrapperFlex flexWrap="wrap">
        <Box
          px={1}
          my={5}
          width={[1, 1, 1, 11 / 20]}
          textAlign={['center', 'center', 'center', 'left']}
        >
          <Box mb={3}>
            <Text fontWeight="bold" caps fontSize={0} mb={3} color="text.light">
              {smallHeadingText}
            </Text>
            <Text mb={3} fontWeight="bold" fontSize={5}>
              {headingText}
            </Text>
            <Text.span fontSize={3} color="text.light" mb={2}>
              {contentText1}
              <Text.span fontWeight="bold">{contentText2}</Text.span>
              {contentText3}
            </Text.span>
          </Box>
          {appDownloadButtons}
        </Box>
        <FlexDesktopOnly
          flexDirection="column"
          flexWrap="wrap"
          width={[1, null, null, 9 / 20]}
          px={1}
          my={-1}
        >
          <StyledWebPImage
            image={image}
            imageWebP={imageWebP}
            imageSize={imageSize}
            height="100%"
          />
        </FlexDesktopOnly>
      </WrapperFlex>
    </Box>
  )
}

AppDownload.propTypes = {
  category: PropTypes.string.isRequired
}
